import { render, staticRenderFns } from "./BlockInfos.vue?vue&type=template&id=ea109400&"
import script from "./BlockInfos.vue?vue&type=script&lang=js&"
export * from "./BlockInfos.vue?vue&type=script&lang=js&"
import style0 from "./BlockInfos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports